import React, { Suspense } from 'react';
import { Route, Routes, Navigate } from "react-router";

import { LogoLoading } from "../../components/Loading";

const Login = React.lazy(()=>import('../../pages/Login'));
const ForgotPassword = React.lazy(()=>import('../../pages/ForgotPassword'));
const SetPassword = React.lazy(()=>import('../../pages/SetPassword'));
const RedirectDownload = React.lazy(()=>import('../../pages/RedirectDownload/RedirectDownload'));
const ClientExportsRedirectDownload = React.lazy(()=>import('../../pages/ClientExportsRedirectDownload'));
const ExternalFileDetailPage = React.lazy(()=>import('../../pages/ExternalFileDetails'));
const ExternalSharedFolder = React.lazy(()=>import('../../pages/ExternalFolder'));


function AuthRoute() {

    return (
        <>
            <Suspense fallback={<LogoLoading />}>
                <Routes>
                    <Route path='/' element={<Login />} />
                    <Route path='/forgot-password' element={<ForgotPassword />} />
                    <Route path='/activate-account/:token' element={<SetPassword />} />
                    <Route path='/reset-password/:token' element={<SetPassword />} />

                    <Route path='/file-download/:id' element={<RedirectDownload />} />
                    <Route path='/clients-export-file-download/:id' element={<ClientExportsRedirectDownload />} />

                    <Route path={`external-file-detail/:id`} element={<ExternalFileDetailPage />} />
                    <Route path={`external-folder/:id`} element={<ExternalSharedFolder />} />
                    {/* api/repo/folder/857/content? */}

                    <Route path='*' element={<Navigate to="/" />} />
                </Routes>
            </Suspense>
        </>
    )
}

export default AuthRoute
